import DeleteIcon from "@mui/icons-material/Delete";
import {
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import { useCallback } from "react";
import type { SourceInstance } from "../../../utils/settings/types";

export type ConfiguredAccountsProps = {
  readonly accounts: readonly SourceInstance[];
  readonly onDelete: (identifier: SourceInstance) => void;
};

export function ConfiguredAccounts({
  accounts,
  onDelete,
}: ConfiguredAccountsProps): JSX.Element {
  if (accounts.length === 0) {
    return (
      <>
        No configured sources!
        <br />
      </>
    );
  }

  return (
    <>
      <Typography component="div" variant="h6">
        Configured Accounts
      </Typography>
      <List dense>
        {accounts.map((account) => (
          <Account
            key={`bq-act-${account.source_identifier}`}
            account={account}
            onDelete={onDelete}
          />
        ))}
      </List>
    </>
  );
}

function Account({
  account,
  onDelete,
}: {
  readonly account: ConfiguredAccountsProps["accounts"][number];
  readonly onDelete: (identifier: SourceInstance) => void;
}): JSX.Element {
  const handleDeleteClick = useCallback(() => {
    onDelete(account);
  }, [account, onDelete]);
  const [accountId, warehouse] = account.source_identifier.split(",");

  return (
    <ListItem>
      <ListItemText primary={accountId} secondary={warehouse} />
      <ListItemSecondaryAction>
        <IconButton aria-label="delete" edge="end" onClick={handleDeleteClick}>
          <DeleteIcon sx={{ color: "palevioletred" }} />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
}
